import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AlertIcon, ErrorIcon, SuccessIcon } from '../../Icon';
import { Button } from '../../Button';
import { useTranslation } from '@ciam/i18n';
export const useModalRender = (props) => {
    const { t } = useTranslation('ui');
    const { type, onConfirm, onCancel, handleCancel, handleConfirm, hideButtons } = props;
    const renderIcon = () => {
        const iconMap = {
            error: _jsx(ErrorIcon, {}),
            success: _jsx(SuccessIcon, {}),
            alert: _jsx(AlertIcon, {}),
            warning: _jsx(AlertIcon, {}),
        };
        return type ? iconMap[type] : null;
    };
    const renderTextWithLineBreaks = (text, keyPrefix) => {
        return text.split('<br>').map((line, i) => (_jsxs(React.Fragment, { children: [i > 0 && _jsx("br", {}), line] }, `${keyPrefix}_line${i}`)));
    };
    const renderButtons = () => {
        if (hideButtons)
            return null;
        const cancelBtn = (_jsx(Button, { type: "button", size: "m", buttonTheme: "white", onClick: handleCancel, children: t('modal.button.cancel') }));
        const confirmBtn = (_jsx(Button, { type: "button", size: "m", buttonTheme: "blue", onClick: handleConfirm, children: t('modal.button.confirm') }));
        if (type === 'error')
            return cancelBtn;
        if (type === 'success')
            return confirmBtn;
        if (type === 'alert' || type === 'warning') {
            if (onConfirm && !onCancel)
                return confirmBtn;
            if (onConfirm)
                return (_jsxs(_Fragment, { children: [cancelBtn, confirmBtn] }));
            return cancelBtn;
        }
    };
    return {
        renderIcon,
        renderTextWithLineBreaks,
        renderButtons,
    };
};
//# sourceMappingURL=useModalRender.js.map